<script setup>
import { ref, onMounted } from 'vue'
import axios from '@axios'

const stats = ref(null)
const loading = ref(false)

onMounted(async () => {
  loading.value = true
  try {
    const { data } = await axios.get('/user/me/restaurant-scope')
    stats.value = { restaurantCount: data.restaurants?.length ?? 0 }
  } catch {
    stats.value = { restaurantCount: 0 }
  } finally {
    loading.value = false
  }
})
</script>

<template>
  <VContainer class="admin-discover">
    <div class="admin-discover__header">
      <h1 class="admin-discover__title">
        Restaurant Discover
      </h1>
      <p class="admin-discover__subtitle">
        Restaurant Discover is coming soon.
      </p>
    </div>

    <VCard
      v-if="stats"
      class="admin-discover__stat-card"
      variant="outlined"
    >
      <VCardText class="admin-discover__stat-body">
        <div class="admin-discover__stat-value">
          {{ stats.restaurantCount }}
        </div>
        <div class="admin-discover__stat-label">
          Restaurant{{ stats.restaurantCount !== 1 ? 's' : '' }} you manage
        </div>
      </VCardText>
    </VCard>
    <VProgressCircular
      v-else-if="loading"
      indeterminate
      color="primary"
      class="d-block mx-auto mt-8"
    />
  </VContainer>
</template>

<style scoped>
.admin-discover {
  max-width: 640px;
  padding-top: var(--ds-space-8, 32px);
}

.admin-discover__header {
  margin-bottom: var(--ds-space-6, 24px);
}

.admin-discover__title {
  font-size: var(--ds-text-2xl, 28px);
  font-weight: 700;
  color: var(--ds-text-strong, inherit);
  margin-bottom: var(--ds-space-2, 8px);
}

.admin-discover__subtitle {
  font-size: var(--ds-text-base, 16px);
  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
}

.admin-discover__stat-card {
  border-radius: var(--ds-radius-lg, 12px);
}

.admin-discover__stat-body {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: var(--ds-space-1, 4px);
  padding: var(--ds-space-5, 20px) var(--ds-space-5, 20px);
}

.admin-discover__stat-value {
  font-size: var(--ds-text-3xl, 36px);
  font-weight: 700;
  color: var(--ds-brand-primary-dark, #3F998F);
  line-height: 1;
}

.admin-discover__stat-label {
  font-size: var(--ds-text-sm, 14px);
  color: rgba(var(--v-theme-on-surface), var(--v-medium-emphasis-opacity));
}
</style>

<route lang="yaml">
meta:
  layout: website
  action: read
  subject: Auth
  allowLoggedInOnly: true
  requiresRestaurantAdmin: true
</route>
